export const SET_MAILING_COUPON_CONFIGS = 'SET_MAILING_COUPON_CONFIGS'
